module.exports = __webpack_public_path__ + "tech_hall-d0e987f9c73092863517138ec6d05058.png";